<div class="loading-spinner-fullscreen"><app-loading-spinner></app-loading-spinner></div>
<div class="loading-spinner-fullscreen-backdrop"></div>
